var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDollarsIcon = function SvgDollarsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#15803D",
    d: "M3 5c0-1.094.875-2 2-2h13c1.094 0 2 .906 2 2v7c0 1.125-.906 2-2 2H5c-1.125 0-2-.875-2-2zm2 5v2h2c0-1.094-.906-2-2-2m2-5H5v2c1.094 0 2-.875 2-2m11 5c-1.125 0-2 .906-2 2h2zm-2-5c0 1.125.875 2 2 2V5zM9 8.5a2.53 2.53 0 0 0 1.25 2.188c.75.437 1.719.437 2.5 0C13.5 10.218 14 9.406 14 8.5c0-.875-.5-1.687-1.25-2.156-.781-.438-1.75-.438-2.5 0C9.469 6.812 9 7.625 9 8.5M1.5 5.75v7.5c0 1.25 1 2.25 2.25 2.25h12.5a.76.76 0 0 1 .75.75.74.74 0 0 1-.75.75H3.75A3.72 3.72 0 0 1 0 13.25v-7.5A.74.74 0 0 1 .75 5a.76.76 0 0 1 .75.75"
  })));
};
export default SvgDollarsIcon;